import React, { createContext, useContext, useState, useEffect } from 'react';
import { toast } from 'sonner';
import { useLanguage } from './LanguageContext';

const CompareContext = createContext();

export const useCompare = () => {
  const context = useContext(CompareContext);
  if (!context) {
    throw new Error('useCompare must be used within CompareProvider');
  }
  return context;
};

export const CompareProvider = ({ children }) => {
  const { language } = useLanguage();
  const [compareList, setCompareList] = useState([]);
  const MAX_COMPARE = 3;

  // Load compare list from localStorage
  useEffect(() => {
    const saved = localStorage.getItem('allmx_compare');
    if (saved) {
      try {
        setCompareList(JSON.parse(saved));
      } catch (error) {
      }
    }
  }, []);

  // Save to localStorage
  useEffect(() => {
    localStorage.setItem('allmx_compare', JSON.stringify(compareList));
  }, [compareList]);

  const addToCompare = (product) => {
    if (compareList.find(item => item.sku === product.sku)) {
      toast.info(language === 'it' ? 'Prodotto già in confronto' : 'Product already in comparison');
      return;
    }
    
    if (compareList.length >= MAX_COMPARE) {
      toast.error(language === 'it' ? `Massimo ${MAX_COMPARE} prodotti` : `Maximum ${MAX_COMPARE} products`, { duration: 2000 });
      return;
    }
    
    setCompareList(prev => [...prev, product]);
    toast.success(language === 'it' ? '⚖️ Aggiunto al confronto!' : '⚖️ Added to comparison!', { duration: 2000 });
  };

  const removeFromCompare = (sku) => {
    setCompareList(prev => prev.filter(item => item.sku !== sku));
    toast.success(language === 'it' ? 'Rimosso dal confronto' : 'Removed from comparison', { duration: 2000 });
  };

  const isInCompare = (sku) => {
    return compareList.some(item => item.sku === sku);
  };

  const clearCompare = () => {
    setCompareList([]);
    toast.success(language === 'it' ? 'Confronto svuotato' : 'Comparison cleared', { duration: 2000 });
  };

  return (
    <CompareContext.Provider value={{ 
      compareList, 
      addToCompare, 
      removeFromCompare, 
      isInCompare,
      clearCompare,
      maxCompare: MAX_COMPARE
    }}>
      {children}
    </CompareContext.Provider>
  );
};
